"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePayloadFromQsParam = exports.encodePayloadForQsParam = void 0;
const fast_safe_stringify_1 = __importDefault(require("fast-safe-stringify"));
const btoa_lite_1 = __importDefault(require("btoa-lite"));
const atob_lite_1 = __importDefault(require("atob-lite"));
const logger_lib_support_1 = require("../support/logger-lib-support");
const error_record_util_1 = require("../exceptions/error-record-util");
/**
 * Transforms a data object/record so it can be safely embedded in a url as a search param.
 * Such values should be decoded using `decodePayloadFromQsParam`.
 *
 * Note: only pass in the value, not the qs param key. Eg, `?payload=${ encodePayloadForQsParam(theData) }`
 *
 * It does three transforms:
 * 1) JSON-stringify the data using the 'fast-safe-stringify' lib;
 * 2) "binary-to-ascii" conversion using isomorphic 'btoa-lite lib. See [btoa](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa) for base64;
 * 3) encodeURIComponent using the [native function](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent) to handle non-url-safe base64 characters
 *
 * @param data
 */
function encodePayloadForQsParam(data) {
    return data ? encodeURIComponent(btoa_lite_1.default(fast_safe_stringify_1.default(data))) : '';
}
exports.encodePayloadForQsParam = encodePayloadForQsParam;
/**
 * Decodes data encoded by `encodePayloadForQsParam`.
 *
 * @param raw
 */
function decodePayloadFromQsParam(raw) {
    if (typeof raw !== 'string') {
        return;
    }
    if (!raw.length) {
        return {};
    }
    let res;
    try {
        const json = atob_lite_1.default(decodeURIComponent(raw)); // must be encoded as: encodeURIComponent(btoa(JSON.stringify(data)))
        res = JSON.parse(json);
    }
    catch (err) {
        logger_lib_support_1.loggerIsoLib().warn({
            error: error_record_util_1.jsErrorToRecord(err),
            rawString: raw,
        }, 'Failed to decode and parse string');
    }
    return res;
}
exports.decodePayloadFromQsParam = decodePayloadFromQsParam;
//# sourceMappingURL=url-data-codec.js.map